module.exports = __webpack_public_path__ + "static/media/logo-black.1f431698.png";